import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RRVirtualTryonSettingsModel } from '../models/virtual-tryon-settings.model';

@Injectable({
  providedIn: 'root',
})
export class RRVirtualTryonChangeService {
  public settingsChanged: Subject<RRVirtualTryonSettingsModel> =
    new Subject<RRVirtualTryonSettingsModel>();
}
